import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PromotionNaviBox } from "../../../../components/navBox/promotion-naviBox";
import { getCookie } from "../../../../util/cookie/cookies";
import { useGetUserContentListMutation } from "../../../../store/user/contentsApiSlice";
import { Paginate } from "../../../../components/paginate/paginate";
interface ParamData {contentsType : any, lang : string, page : any, size : number, keyword : string, sortOrder : string, sortColumn : string}
export const PromotionCatalogue = () => {
    const lang = getCookie('HYUNDAILANG')
    const location = useLocation()
    const page : any = new URLSearchParams(location.search).get('page') || 1;
    const navigate = useNavigate()
    const [totalCount, setTotalCount] = useState<number>(0)
    const [param , setParam] = useState<ParamData>({contentsType : 3, lang : lang === 'kr' ? 'KR' : 'EN', page : page, size : 8, keyword : '', sortOrder : 'desc', sortColumn : 'date'})
    const [getUserContentListApi] = useGetUserContentListMutation()
    const [data, setData] = useState<any>([])
    const getList = async() => {
        const result : any = await getUserContentListApi(param)
        if(result.data.result === true){
            setData(result.data.list); setTotalCount(result.data.totalCount)
        }
    }
    const handlePage = (pageNumber : number) => {
        if(parseInt(page) !== pageNumber){navigate(`${location.pathname}?page=${pageNumber}`)}
    }
    const handleDownLoad = (file : any) => {
        if(!file){alert("첨부파일이 존재하지 않습니다.");}
        else{
            const fileUrl: any = file;
            const filePath = fileUrl.substring(fileUrl.lastIndexOf('/') + 1);
            const downLoad = document.createElement('a');
            downLoad.download = filePath;
            downLoad.href = fileUrl;
            downLoad.target = "_blank";
            document.body.appendChild(downLoad);
            downLoad.click();
            document.body.removeChild(downLoad);
        }
    }
    useEffect(()=>{
        if(lang === 'kr'){setParam((prev)=>({...prev, lang : 'KR'}))}
        else {setParam((prev)=>({...prev, lang : 'EN'}))}
    }, [lang])
    useEffect(()=>{setParam((prev)=>({...prev, page : page}))}, [page])
    useEffect(()=>{getList()}, [param.lang, param.page])
    return(
        <>
        <div className="contentBox">
            <div>
                <div className="left stickyBox">
                    <h3>
                        <span>현대엔테크</span>
                        홍보자료
                    </h3>
                    
                    <PromotionNaviBox/>
                </div>
                <div className="right">
                    <ul>
                        {data?.map((list:any, index : number) => (
                        <li key={index} onClick={()=>handleDownLoad(lang === 'kr' ? list?.prom_contents_File_kr : list?.prom_contents_File_en)}>
                            <p>{lang === 'kr' ? list?.prom_subject_kr : list?.prom_subject_en}</p>
                            <button>DOWNLOAD</button>
                        </li>
                        ))}
                    </ul>
                </div>
            </div>
            <ol className="pager">
                <Paginate page={page} size={8} totalCount={totalCount} setPage={handlePage}/>
            </ol>
        </div>
        </>
    )
}